import React, { useEffect } from 'react'
import PageWrapper from 'Pages/@PageWrapper'
import { Grid } from '@mui/material'
import { ADMIN_ROUTES } from '@constants'
import ReportsHandleTable from 'Pages/Admin/ReportsHandler/Table'
import ReportsHandlerUserOriginFilter from 'Pages/Admin/ReportsHandler/UserOrigin'
import ReportsHandlerModal from 'Pages/Admin/ReportsHandler/Modal'
import { reportsHandlerClearSignals } from 'Pages/Admin/ReportsHandler/@signals'


export default function ReportsHandlerAdminPage() {

	useEffect(() => {
		reportsHandlerClearSignals()
		return () => {
			reportsHandlerClearSignals()
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.REPORT_HANDLER_SUBTITLE}
		isEmpty={false}
	>
		<Grid container spacing={2}>
			<Grid item xs={3}>
				<ReportsHandlerUserOriginFilter />
			</Grid>
			<Grid item xs={12}>
				<ReportsHandleTable />
			</Grid>
			<Grid item xs={12}>
				<ReportsHandlerModal />
			</Grid>
		</Grid>
	</PageWrapper>
}